// src/components/CustomFilterButton/CustomFilterButton.jsx
import React from 'react'
import { Button } from '@mui/material'

/**
 * @param {{
 *   label: string,
 *   color: string,            // text & border when unselected
 *   backgroundColor: string,  // fill color when selected
 *   selected?: boolean,
 *   onClick: () => void
 * }} props
 */
const CustomFilterButton = ({
  label,
  color,
  backgroundColor,
  selected = false,
  onClick,
  height,
  border = '2px solid',
  sx = {},
}) => (
  <Button
    onClick={onClick}
    disableElevation
    sx={{
      textTransform: 'none',
      fontWeight: 500,
      whiteSpace: 'nowrap',
      px: 2,
      py: 0.5,
      minWidth: 'auto',
      borderRadius: '5px',
      // lineHeight: 1.5,
      height: height ? height: '30px',
      border: border,
      // when selected → filled bg + white text + no visible border
      ...(selected
        ? {
            bgcolor: backgroundColor,
            color: '#ffffff',
            borderColor: backgroundColor,
          }
        : {
            // when unselected → transparent bg + colored text + colored border
            bgcolor: 'transparent',
            color: color,
            borderColor: color,
            '&:hover': {
              // very subtle tinted hover
              bgcolor: `${color}20`,
            },
          }),
      ...sx,
    }}
  >
    {label}
  </Button>
)

export default CustomFilterButton
